// Api
export const API_START = "API_START";
export const API_END = "API_END";
export const API_ERROR = "API_ERROR";
export const API_FAILURE = "API_FAILURE";

// Menu
export const TOGGLE_SIDEBAR = "TOGGLE_SIDEBAR";

// System Messages
export const DISMISS_NOTIFICATION = "DISMISS_NOTIFICATION";
export const DISPLAY_NOTIFICATION = "DISPLAY_NOTIFICATION";

// Authentication
export const REHYDRATE = "REHYDRATE";
export const LOGIN = "LOGIN";
export const LOGOUT = "LOGOUT";
export const CHOOSE_COMPANY = "CHOOSE_COMPANY";
export const CHANGE_STATE = "CHANGE_STATE";

// User
export const UPDATE_USER = "UPDATE_USER";

// Chat
export const UPDATE_CHAT = "UPDATE_CHAT";
export const SET_SEARCH_IN_CHAT = "SET_SEARCH_IN_CHAT";
export const CLEAR_SEARCH_IN_CHAT = "CLEAR_SEARCH_IN_CHAT";
export const SET_CURRENT_CHAT = "SET_CURRENT_CHAT";
export const GET_CHATS = "GET_CHATS";
export const GET_CHATS_H = "GET_CHATS_H";
export const GET_CHAT_DETAILS = "GET_CHAT_DETAILS";
export const TAKE_CHAT = "TAKE_CHAT";
export const CLOSE_CHAT = "CLOSE_CHAT";
export const FREE_CHAT = "FREE_CHAT";
export const TRANSFER_CHAT = "TRANSFER_CHAT";
export const SCHEDULE_CHAT = "SCHEDULE_CHAT";
export const TAG_CHAT = "TAG_CHAT";
export const SHEDULE_CHAT = "SHEDULE_CHAT";
export const CHAT_TAKEN = "CHAT_TAKEN";
export const CHAT_FREED = "CHAT_FREED";
export const CHAT_TRANSFERRED = "CHAT_TRANSFERRED";
export const CHAT_CLOSED = "CHAT_CLOSED";
export const TOGGLE_VIEW_AUTOGESTION = "TOGGLE_VIEW_AUTOGESTION";

// Messages
export const GET_REMAINING_MESSAGES = "GET_REMAINING_MESSAGES";
export const RECEIVE_MESSAGE = "RECEIVE_MESSAGE";
export const MESSAGE_LOCAL = "MESSAGE_LOCAL";
export const MESSAGE_SENT = "MESSAGE_SENT";
export const MESSAGE_READ = "MESSAGE_READ";
export const MESSAGE_FAIL = "MESSAGE_FAIL";
export const SET_REPLY = "SET_REPLY";
export const REMOVE_REPLY = "REMOVE_REPLY";

// Calls
export const INCOMING_CALL = "INCOMING_CALL";
export const UPDATE_CALL = "UPDATE_CALL";
export const CLEAR_CALL = "CLEAR_CALL";
export const CALL_COMMAND_START = "CALL_COMMAND_START";
export const CALL_COMMAND_END = "CALL_COMMAND_END";
export const SET_CALL_MUTE = "SET_CALL_MUTE";

// History
export const SET_CURRENT_CHATH = "SET_CURRENT_CHATH";

// Company
export const UPDATE_COMPANY = "UPDATE_COMPANY";

// Contact
export const UPDATE_CONTACT = "UPDATE_CONTACT";

// Draft
export const SET_DRAFT = "SET_DRAFT";
export const CLEAR_DRAFT = "CLEAR_DRAFT";

// Panels
export const SET_PANEL = "SET_PANEL";
